module.exports = __webpack_public_path__ + "img/LAL_login_btn_AI.ef414878.svg";